import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
	Card,
	CardBody,
	CardText,
	CardTitle,
	Col,
	Modal,
	ModalBody,
	ModalHeader,
	Row,
} from 'reactstrap';
import { downloadFile, getFile } from '../../../../slices/thunks';
import OPlaceholder from '../../../../Components/OElements/OPlaceholder';
import { Icons } from '../../../../utils/Icons';

const WorkFileModal = ({ workData, isOpen, handleToggleModal }) => {
	const dispatch = useDispatch();

	const [fileData, setFileData] = useState(null);
	const [loading, setLoading] = useState(false);
	const [fileDownloadLoading, setFileDownloadLoading] = useState(null);
	const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
	const [previewFile, setPreviewFile] = useState(null);

	useEffect(() => {
		const fetchFile = async () => {
			if (!workData?.file_id) {
				setFileData(null);
				return;
			}
			setLoading(true);
			try {
				const response = await dispatch(getFile(workData.file_id));
				setFileData(response.payload);
			} catch (error) {
				console.error('Error fetching file:', error);
			} finally {
				setLoading(false);
			}
		};

		if (isOpen) fetchFile();
	}, [workData?.file_id, isOpen, dispatch]);

	const handleDownloadFile = file => {
		setFileDownloadLoading(file._id);
		dispatch(downloadFile({ file_id: file._id }))
			.then(data => {
				const payload = data.payload;
				const url = window.URL.createObjectURL(payload);
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', `${file.filename}${file.extension}`);
				document.body.appendChild(link);
				link.click();
				link.remove();
			})
			.finally(() => setFileDownloadLoading(null));
	};

	const handlePreviewClick = async file => {
		try {
			const result = await dispatch(downloadFile({ file_id: file._id, disable_msg: true }));
			const blob = result.payload;
			if (!(blob instanceof Blob)) {
				throw new Error('El archivo no es un Blob válido.');
			}
			const fileURL = URL.createObjectURL(blob);
			setPreviewFile({ ...file, url: fileURL });
			setIsPreviewModalOpen(true);
		} catch (error) {
			console.error('Error al obtener el archivo:', error);
		}
	};

	return (
		<div>
			<Modal
				isOpen={isOpen}
				toggle={handleToggleModal}
				size='lg'
				className='border-0'
				modalClassName='modal fade zoomIn'
				backdrop='static'
				centered={true}
			>
				<ModalHeader toggle={handleToggleModal}>Documento Adjunto</ModalHeader>
				<ModalBody>
					<Row>
						{loading ? (
							<OPlaceholder />
						) : fileData ? (
							<Col md={6}>
								<Card className='border'>
									<CardBody>
										<Row>
											<Col md={2}>
												<i className={`${Icons.guide} ri-3x`}></i>
											</Col>
											<Col>
												<CardTitle tag='h5' className='mt-2'>
													{fileData?.file_type?.name || 'Documento'}
												</CardTitle>
												<CardText>{fileData?.filename}</CardText>
											</Col>
										</Row>
									</CardBody>
									<CardBody>
										<div className='d-flex align-items-end justify-content-end'>
											<div className='flex-shrink-0'>
												<div className='d-flex flex-wrap gap-2'>
													<button
														className='btn btn-label btn-primary'
														onClick={() => handleDownloadFile(fileData)}
														disabled={fileDownloadLoading === fileData._id}
													>
														<i className='icon-download label-icon'></i>{' '}
														Descargar
													</button>
													<button
														className='btn btn-label btn-primary'
														onClick={() => handlePreviewClick(fileData)}
													>
														<i className='ri-eye-line label-icon'></i>{' '}
														Previsualizar
													</button>
												</div>
											</div>
										</div>
									</CardBody>
								</Card>
							</Col>
						) : (
							<Col className='text-center'>
								<p>No hay documento disponible.</p>
							</Col>
						)}
					</Row>
				</ModalBody>
			</Modal>

			<Modal
				isOpen={isPreviewModalOpen}
				toggle={() => setIsPreviewModalOpen(false)}
				centered={false}
				className='w-100 p-4'
				fullscreen={true}
				scrollable={false}
			>
				<ModalHeader toggle={() => setIsPreviewModalOpen(false)}>
					Previsualización
				</ModalHeader>
				<ModalBody className='overflow-hidden'>
					{previewFile && previewFile.url ? (
						previewFile.mime_type?.includes('image') ? (
							<img
								src={previewFile.url}
								alt={previewFile.filename}
								className='img-fluid'
							/>
						) : previewFile.mime_type?.includes('pdf') ? (
							<iframe src={previewFile.url} width='100%' height='100%' title='preview' />
						) : previewFile.mime_type?.includes('text') ? (
							<pre>{previewFile.content || 'No se pudo cargar el contenido'}</pre>
						) : (
							<p>Formato no compatible para previsualización.</p>
						)
					) : (
						<p>Cargando...</p>
					)}
				</ModalBody>
			</Modal>
		</div>
	);
};

export default WorkFileModal;
